import { AGENT_MONTH_SPENT_CODE } from "@bash/shared";

/**
 * The agent's used-up month (agent wallet, spec 2026-10-15) on the web.
 *
 * Only the server's refusal before a turn (gate-refusal.ts refuseForAgentMonth)
 * carries a sentence naming the agent and the month; its block's code and its
 * outcome's raw subtype are both AGENT_MONTH_SPENT_CODE (the one spelling, in
 * @bash/shared's wallet constants). An engine trip (the turn head, the wallet cap
 * mid-turn) sends no block, so the web synthesizes one whose text is the
 * contract's generic label ("Budget limit reached"). The structured field
 * decides which one a card is holding, never whether the text is empty.
 */
export function isAgentMonthRefusal(
  code: string | undefined,
  outcome: { raw?: { subtype?: string } } | undefined
): boolean {
  return (
    code === AGENT_MONTH_SPENT_CODE ||
    outcome?.raw?.subtype === AGENT_MONTH_SPENT_CODE
  );
}
